import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logoutUser, clearCurrentProfile } from "../../actions/auth";
import { createNotification } from "../../utils/helpers";
import _ from "lodash";
import lang from "../../langs";
import { MdKeyboardBackspace, MdExitToApp } from "react-icons/md";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: ""
    };
  }

  onLogoutClick(e) {
    e.preventDefault();
    this.props.clearCurrentProfile();
    this.props.logoutUser();

    createNotification("info", lang("success.logout"));
  }

  render() {
    let backto = this.props.backto ? this.props.backto : "/dashboard";
    let isParent = this.props.backto ? false : true;
    if (this.props.location.pathname != "/dashboard") {
      if (this.props.location.hash) {
        backto = _.trimStart(this.props.location.hash, "#");
      }
    }

    return (
      <footer className="container">
        <div className="row">
          <div className="col-8 col-offset-2">
            <div className="row justify-content-end">
              <div class="col-3">
                {isParent && (
                  <button
                    type="button"
                    onClick={this.onLogoutClick.bind(this)}
                    className="btn btn-outline-danger"
                  >
                    <MdExitToApp size="1.5em" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

Footer.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStatetoProps = state => ({
  auth: state.auth,
  merchants: state.merchants
});

export default connect(
  mapStatetoProps,
  { logoutUser, clearCurrentProfile }
)(Footer);
